(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sdg-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const root = document.querySelector('[data-sdg-newsletter]');
      if (!root) return;
      const dialog = root.querySelector('dialog');
      const teaser = root.querySelector('[data-sdg-open]');
      const form = root.querySelector('form');
      const completedKey = 'sdg_newsletter_completed_v1';
      const pendingKey = 'sdg_newsletter_pending_v1';
      const dismissedKey = 'sdg_newsletter_dismissed_v1';
      const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
      const write = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };
      let previousFocus;
      const open = () => {
        if (dialog.open) return;
        if (document.querySelector('dialog[open]')) return;
        previousFocus = document.activeElement;
        dialog.showModal();
      };
      const close = () => {
        dialog.close();
        write(sessionStorage, dismissedKey, '1');
        if (previousFocus && previousFocus.isConnected) previousFocus.focus();
      };
      if (root.querySelector('[data-sdg-success]') && read(sessionStorage, pendingKey)) {
        write(localStorage, completedKey, '1');
        write(sessionStorage, pendingKey, '');
        open();
      } else if (!read(localStorage, completedKey)) {
        teaser.hidden = false;
        if (root.querySelector('[data-sdg-error]')) open();
        else if (!read(sessionStorage, dismissedKey)) setTimeout(open, 8000);
      }
      teaser.addEventListener('click', open);
      root.querySelector('[data-sdg-close]').addEventListener('click', close);
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
      form.addEventListener('submit', () => write(sessionStorage, pendingKey, '1'));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
    else init();
  })();

  (() => {
    const init = () => {
      const source = document.getElementById('sdg-douceur-data');
      const page = document.getElementById('sdg-douceur-page');
      const template = document.getElementById('sdg-douceur-template');
      if (!source || !page || !template || page.dataset.ready) return;
      page.dataset.ready = 'true';
      const config = JSON.parse(source.textContent);
      let ids = config.items;
      let requestNumber = 0;
      const hasGuide = () => ids.includes(config.guide);
      const hasDilators = () => ids.includes(config.dilators) || ids.includes(config.box);
      const cartMode = () => hasGuide() === hasDilators() ? '' : hasGuide() ? 'dilators' : 'guide';
      const paint = (panel, mode) => {
        let count = 0;
        panel.querySelectorAll('[data-douceur-kind]').forEach(card => {
          const kind = card.dataset.douceurKind;
          const alreadyAdded = kind === 'guide' ? hasGuide() : hasDilators();
          card.hidden = alreadyAdded || (mode !== 'both' && mode !== kind);
          if (!card.hidden) count++;
        });
        panel.hidden = !count;
        return count;
      };
      const placePage = () => {
        if (page.dataset.page === 'product') {
          const form = document.querySelector('.product__info-container product-form');
          if (form) form.parentElement.insertAdjacentElement('afterend', page);
        } else if (page.dataset.page === 'article') {
          document.querySelector('.article-template__content')?.append(page);
        } else if (page.dataset.page === 'search') {
          document.querySelector('.template-search__header')?.insertAdjacentElement('afterend', page);
        } else if (page.dataset.page === 'cart') {
          document.getElementById('main-cart-footer')?.insertAdjacentElement('beforebegin', page);
        }
      };
      const update = () => {
        const mode = page.dataset.page === 'cart' ? cartMode() : page.dataset.mode;
        page.hidden = !paint(page.querySelector('.sdg-douceur'), mode);
        const host = document.querySelector('#cart-notification .cart-notification__links, cart-drawer .drawer__footer');
        if (host) {
          let panel = host.parentElement.querySelector('[data-douceur-cart]');
          if (!panel) {
            panel = template.content.firstElementChild.cloneNode(true);
            panel.dataset.douceurCart = 'true';
            host.before(panel);
          }
          paint(panel, cartMode());
        }
      };
      const refresh = async () => {
        const number = ++requestNumber;
        try {
          const response = await fetch(config.cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!response.ok) return;
          const cart = await response.json();
          if (number !== requestNumber || !Array.isArray(cart.items)) return;
          ids = cart.items.map(item => item.product_id);
          update();
        } catch (_) {}
      };
      placePage();
      update();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
